import { restApi } from '../../../services/Api'

const veiculosRepository = {
  veiculoKmm: placa => {
    return restApi.get(`veiculosKmm/${placa}`)
  },
  conjuntoKmm: placa => {
    return restApi.get(`veiculosKmm/conjunto/${placa}`)
  },
  findConjuntoKmmByPlacaForSolicitacao: (solicitacaoId, placa) => {
    return restApi.get(`/veiculosKmm/${solicitacaoId}/conjunto/${placa}`)
  }
}

export default veiculosRepository
